const config = {
  annualMultiplier: 12,
  sumMultiplier: 20,
  outputFactor: 0.12,
  maxAmount: 5000,
};

export default config;
